import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import 'react-dates/lib/css/_datepicker.css';
import handleChange from '../../utils/handleChange';
import errorHandle from '../../utils/errorHandle';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import { getFormattedDateReverse } from '../../utils/date';
import { SingleDatePicker } from 'react-dates';
import { SupOrgDatesContext } from '../../context/SupOrgDatesContest';
import { supTripDateEdit, supTripOrgDateFun } from '../../api/supportAdmin';

export default function SupTripDateEditTab({ id, date, setEditModal, setDates, refresh }) {
    const [dateDetails, setDateDetails] = useState({
        totalSlots: '',
        totalRooms: '',
        price: {
            actual: '',
            tax: '',
            total: '',
            reserve: ''
        }
    });
    const [isChecked, setIsChecked] = useState(false);
    const isMobile = window.innerWidth < 768;
    const [bookingEndDate, setBookingEndDate] = useState(null);
    const [bookingEndFocused, setBookingEndFocused] = useState(null);

    const [loading, setLoading] = useState(false);

    const notAllowedDates = useRef([]);
    const { dates, upComing } = SupOrgDatesContext;

    // useEffect(() => {
    //     if (isExpanded && bookingTabRef.current) {
    //         window.scrollTo({
    //             top: bookingTabRef.current.offsetTop - 160,
    //             behavior: 'smooth'
    //         });
    //     }
    // }, [isExpanded]);

    useEffect(() => {
        if (date) {
            setDateDetails({
                totalSlots: date.totalSlots || '',
                totalRooms: date.totalRooms || '',
                bookingEnd: date?.bookingEnd || '',
                price: {
                    actual: date?.price?.actual || '',
                    tax: date?.price?.tax || '',
                    total: date?.price?.total || '',
                    reserve: date?.price?.reserve || ''
                }
            });
            if (date?.bookingEnd) {
                setBookingEndDate(moment(date.bookingEnd));
            }

            if (date?.price && (date?.price?.actual || date?.price?.tax || date?.price?.total)) {
                setIsChecked(true);
            }
        }
    }, [date]);

    useEffect(() => {
        const actual = Number(dateDetails.price.actual);
        if (!isNaN(actual) && actual > 0) {
            const tax = Math.round(actual * 0.05);
            const total = Math.round(actual + tax);
            setDateDetails((prev) => ({
                ...prev,
                price: {
                    ...prev.price,
                    tax,
                    total
                }
            }));
        } else {
            setDateDetails((prev) => ({
                ...prev,
                price: {
                    ...prev.price,
                    tax: '',
                    total: ''
                }
            }));
        }
    }, [dateDetails.price.actual]);

    useEffect(() => {
        if (upComing) {
            notAllowedDates.current = dates.map((da) => moment(da.startDate));
            const today = new Date();
            const twoDates = [
                moment(today),
                moment(new Date().setDate(today.getDate() + 1)),
                moment(new Date().setDate(today.getDate() + 2))
            ];
            notAllowedDates.current = [...notAllowedDates.current, ...twoDates];
        }
        // eslint-disable-next-line
    }, [dates]);

    // const toggleExpand = () => {
    //     setIsExpanded(!isExpanded);
    // };

    const handleSubmit = async () => {
        const packId = window.location.pathname.split('/')[5];

        if (!dateDetails.totalSlots) {
            toast.error('Please enter total slots');
            return;
        }
        // Update slots
        setLoading(true);
        try {
            let priceData = {};
            if (
                dateDetails.price?.actual ||
                dateDetails.price?.tax ||
                dateDetails.price?.total ||
                dateDetails.price?.reserve
            ) {
                priceData = {
                    price: {
                        actual: dateDetails.price.actual,
                        tax: dateDetails.price.tax,
                        total: dateDetails.price.total,
                        reserve: dateDetails.price.reserve
                    }
                };
            }
            const response = await supTripDateEdit(date?.status, {
                packDateId: id,
                totalSlots: dateDetails.totalSlots,
                totalRooms: dateDetails.totalRooms,
                bookingEnd: bookingEndDate || dateDetails.bookingEnd,
                ...priceData
            });

            if (response.status === 200) {
                toast.success('Slots updated successfully');
                setEditModal(false);
                const dateData = await supTripOrgDateFun(packId, 'next');
                const sortedDates = dateData.data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
                setDates(sortedDates);
                refresh();
            }
        } catch (error) {
            errorHandle(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCheckBoxChnage = (event) => {
        setIsChecked(event.target.checked);
    };

    return (
        <div className={`orgTripBookingTab`} style={{ maxHeight: 500, overflowX: 'hidden', overflowY: 'auto' }}>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}{' '}
            {/* <button onClick={toggleExpand} className='collapseArrow'>
                <Chevron width={24} height={24} />
            </button> */}
            <div className='tripBookingSubTab'>
                <label className='tripBookDatalabel2'>Booking End Date</label>
                <SingleDatePicker
                    withPortal={isMobile}
                    date={bookingEndDate}
                    onDateChange={(date) => {
                        setBookingEndDate(date);
                    }}
                    displayFormat='DD-MM-YYYY'
                    focused={bookingEndFocused}
                    onFocusChange={({ focused }) => setBookingEndFocused(focused)}
                    numberOfMonths={1}
                    isOutsideRange={(day) =>
                        day.isBefore(moment(), 'day') || day.isAfter(moment(date?.startDate), 'day')
                    }
                    showDefaultInputIcon={true}
                    readOnly={true}
                />
                <label className='tripBookDatalabel2'>Start Date</label>
                <div className='itineraryInputDiv'>
                    <input
                        value={getFormattedDateReverse(date.startDate)}
                        disabled
                        name='bookingEnd'
                        className='itineraryInput'
                    ></input>
                </div>

                <label className='tripBookDatalabel2'>End Date</label>
                <div className='itineraryInputDiv'>
                    <input
                        value={getFormattedDateReverse(date.endDate)}
                        disabled
                        name='bookingEnd'
                        className='itineraryInput'
                    ></input>
                </div>

                <label className='tripBookDatalabel2'>Slots</label>
                <input
                    placeholder='Slots'
                    type='number'
                    value={dateDetails.totalSlots}
                    name='totalSlots'
                    className='orgTrDaTabSlotIn'
                    onChange={(e) => handleChange(e, setDateDetails)}
                />
                <label className='tripBookDatalabel2 roomsInputLable'>Rooms</label>
                <input
                    placeholder='Rooms'
                    type='number'
                    value={dateDetails.totalRooms}
                    name='totalRooms'
                    className='orgTrDaTabSlotIn'
                    onChange={(e) => handleChange(e, setDateDetails)}
                />
                <div id='org-checkbox-div'>
                    <input type='checkbox' id='customCheck' checked={isChecked} onChange={handleCheckBoxChnage} />
                    <label
                        htmlFor='customCheck'
                        id='tripReserveLabel'
                        style={{ marginBottom: '10px', lineHeight: '16px' }}
                    >
                        If you want to add special price for this date
                    </label>
                </div>
                {isChecked && (
                    <>
                        <label className='tripBookDatalabel2 roomsInputLable'>Actual</label>
                        <input
                            placeholder='Actual price'
                            type='number'
                            value={dateDetails?.price?.actual}
                            name='actual'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails, 'price')}
                        />
                        <label className='tripBookDatalabel2 roomsInputLable'>Tax</label>
                        <input
                            placeholder='Tax'
                            type='number'
                            value={dateDetails?.price?.tax}
                            name='tax'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails, 'price')}
                        />
                        <label className='tripBookDatalabel2 roomsInputLable'>Total</label>
                        <input
                            placeholder='Total Price'
                            type='number'
                            value={dateDetails?.price?.total}
                            name='total'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails, 'price')}
                        />
                        <label className='tripBookDatalabel2 roomsInputLable'>Reserve</label>
                        <input
                            placeholder='Reserve Price'
                            type='number'
                            value={dateDetails?.price?.reserve}
                            name='reserve'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails, 'price')}
                        />
                    </>
                )}

                <button type='button' className='dateAddBtn blueBtn' onClick={handleSubmit}>
                    Update
                </button>
            </div>
        </div>
    );
}
